import React from 'react';
import { motion } from 'framer-motion';
export function PriceSection() {
  return <section className="py-12 md:py-24 px-4 md:px-6 bg-navy-900 relative overflow-hidden" data-id="element-121">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold-500/10 rounded-full blur-3xl -z-10 pointer-events-none" data-id="element-122"></div>

      <div className="max-w-3xl mx-auto text-center" data-id="element-123">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-124">
          <h2 className="text-2xl md:text-4xl font-serif font-bold mb-5 md:mb-8" data-id="element-125">
            Probablemente estés pensando: <br data-id="element-126" />
            <span className="text-gold-500 italic" data-id="element-127">
              "Si este sistema es tan potente, ¿por qué solo cuesta $6.36?"
            </span>
          </h2>

          <div className="space-y-4 md:space-y-6 text-base md:text-lg text-gray-300 font-light leading-relaxed text-left bg-navy-800 p-5 md:p-8 rounded-2xl border border-white/5 mb-8 md:mb-12" data-id="element-128">
            <p className="font-medium text-white" data-id="element-129">
              La respuesta es simple: Este es mi filtro de compromiso.
            </p>
            <p data-id="element-130">
              Podría dar esto gratis, pero lo que no cuesta, no se valora. Solo
              busco personas que tengan la "piel en el juego". Si no eres capaz
              de invertir el costo de un café en tu propia autoridad visual,
              entonces no tienes lo que se necesita para dominar el mercado en
              2026.
            </p>
            <p data-id="element-131">
              Estos $6.36 son tu contrato personal. Es la señal de que eres un
              ejecutor y no un simple coleccionista de información.
            </p>
          </div>

          <motion.button whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="w-full md:w-auto px-6 py-4 md:px-8 md:py-5 bg-gradient-to-r from-gold-600 to-gold-500 text-navy-900 font-bold text-base md:text-xl rounded-xl shadow-lg hover:shadow-gold-500/25 transition-all duration-300 animate-pulse-glow uppercase tracking-wide" data-id="element-132">
            Acepto el Compromiso — Acceso Total por $6.36
          </motion.button>
        </motion.div>
      </div>
    </section>;
}